
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/license",
      function () {
        return require("private-next-pages/[locale]/license/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/license"])
      });
    }
  